angular.module('rental')
    .controller('RentalAgreementPaymentRegistryEditController', function (modals, $scope, $rootScope, $uibModalInstance, data, RentalAgreementConst, RentalAgreementPaymentRegistry, InvoiceService, RentalAgreementPaymentRegistryService) {
        this.$onInit = () => {
            RentalAgreementPaymentRegistry.get({id: data.id}).$promise.then(result => {
                this.item = result
                this.calculateTotal()
            })
        }
        this.add = () => {
            this.item.items.push({})
        }
        this.addAmount = (amount) => {
            let item = this.item.items.find(item => item.amount == null);
            if(item == null) {
                item = {
                    amount: amount,
                }
                this.item.items.push(item)
            }
            else {
                item.amount = amount
            }
            this.onAmountChanged(item)
        }
        this.remove = ($index) => {
            this.item.items.splice($index, 1)
            this.calculateTotal()
        }
        this.onAmountChanged = (item) => {
            this.calculateTotal()
        }
        this.calculateTotal = () => {
            let totalAmount = InvoiceService.sumDecimal(this.item.items.map(item => item.amount));
            this.total = {
                amount: totalAmount,
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.delete = () => RentalAgreementPaymentRegistryService.delete(data.id).then(() => $uibModalInstance.close())
        this.save = () => {
            let form = {
                id: data.id,
                ...this.item
            }
            return RentalAgreementPaymentRegistry.save(form).$promise.then(result => {
                $rootScope.$broadcast(RentalAgreementConst.eventUpdate, result);
                $uibModalInstance.close(result);
            })
        }
    })
